import React from 'react';
import styled from 'styled-components';

import { RewardBadgePill } from 'src/payments/components/reward-badge-pill/reward-badge-pill';
import type { ValidIncentiveValue } from 'src/payments/hooks/shared/incentive-types';

type CashBackBadgeProps = {
  value: ValidIncentiveValue;
};

export const CashBackBadge = ({ value }: CashBackBadgeProps): JSX.Element => (
  <Badge $prefix='cart-cash-back' data-testid='pbb-cash-back-badge'>
    ${value} back
  </Badge>
);

const Badge = styled(RewardBadgePill).withConfig({ componentId: 'cart-cash-back-badge-pill' })``;
